<template>
  <Loader :value="promise" theme="default" class="task-reference-contact">
    <Contact v-if="item" :value="item" theme="list" :avatar-size="80">
      <template #actions>
        <ButtonComponent
          v-if="showAction && action"
          tag="router-link"
          :to="action"
          :label="$t('gotoItem', [$tc('contact', 1).toLowerCase()])"
          :icon="['fal', 'arrow-to-right']"
          class="task-reference-contact__action mt-1"
        />
      </template>
    </Contact>
  </Loader>
</template>

<script>
import Api from '@/api/Contact'
import Contact from '@/components/Contact/Card'

export default {
  props: {
    value: String,
  },
  watch: {
    value: {
      handler: 'fetch',
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      item: null,
    }
  },
  computed: {
    showAction() {
      return this.action.name !== this.$route.name
    },
    action() {
      return {
        name: 'contact-dashboard',
        params: { id: this.item.id },
      }
    },
  },
  methods: {
    fetch() {
      this.promise = Api.get({ id: this.value }, { query: 'TaskReferenceContact' }).then(item => (this.item = item))
    },
  },
  components: {
    Contact,
  },
}
</script>

<style lang="scss">
.task-reference-contact {
  flex-grow: initial;
  padding-right: 2.5rem;

  &__action {
    font-size: 0.8em !important;
  }
}
</style>
